
import React from 'react';
import { CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { getStatusBadgeClass } from '../device-health/SmartMeterStatusHelpers';
import { Droplet, Flame, Zap } from 'lucide-react';
import { Device } from '../device-health/gis-map/types';

interface DeviceHeaderProps {
  device: any;
  isSmartMeter: boolean;
  deviceType?: string;
  gisDeviceData?: Device | null;
}

const DeviceHeader: React.FC<DeviceHeaderProps> = ({ device, isSmartMeter, deviceType = '', gisDeviceData }) => {
  const deviceTitle = isSmartMeter ? 'Smart Meter' : 'IoT Gateway';
  
  const getUtilityIcon = () => {
    if (deviceType.toLowerCase().includes('water')) {
      return <Droplet className="h-5 w-5 text-sky-500 mr-2" />;
    } else if (deviceType.toLowerCase().includes('gas')) {
      return <Flame className="h-5 w-5 text-amber-500 mr-2" />;
    } else {
      return <Zap className="h-5 w-5 text-emerald-500 mr-2" />;
    }
  };

  return (
    <CardHeader className="pb-3">
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
        <div>
          <div className="flex items-center gap-2">
            <div className="flex items-center">
              {getUtilityIcon()}
              <CardTitle>{deviceType || deviceTitle} Details</CardTitle>
            </div>
            <Badge className={cn("text-xs", getStatusBadgeClass(device.status))}>
              {device.status}
            </Badge>
          </div>
          <p className="text-sm text-muted-foreground mt-1">
            {device.deviceId} - {device.location}
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant="outline" className="text-xs">
            Firmware: {device.firmwareVersion}
          </Badge>
        </div>
      </div>
    </CardHeader>
  );
};

export default DeviceHeader;
